/* eslint-disable linebreak-style */
import { defineMessages } from 'react-intl';

export default defineMessages({
  offlineTitle: {
    id: 'Offline',
    defaultMessage: 'Offline',
  },
  itSeemsToUsThatYouAreOffline: {
    id: 'It seems to us that you are offline',
    defaultMessage: 'It seems to us that you are offline',
  },
  pleaseVerifyYourConnectionAndTryAgain: {
    id: 'Please verify your connection and try again.',
    defaultMessage: 'Please verify your connection and try again.',
  },
  retry: {
    id: 'Retry',
    defaultMessage: 'Retry',
  }
});
